import React from 'react';
import './Infographics.css';

// Import the bookmark icon and the new images
import { FaBookmark } from 'react-icons/fa';
import arrivalsImg from '../../assets/images/infographic-arrivals.png';
import estimatesImg from '../../assets/images/infographic-crop-estimates.png';
import exportsImg from '../../assets/images/infographic-exports.png';
import importsImg from '../../assets/images/infographic-imports.png';

const infographicsData = [
  {
    category: 'Arrivals',
    image: arrivalsImg,
    title: 'Wheat arrivals pegged at 23,575 thousand tonnes till Sep-25',
    date: '02 Oct 2025 17:58:35 IST'
  },
  {
    category: 'Production',
    image: estimatesImg,
    title: 'India\'s Wheat production estimated to rise to 117.5 million tonnes',
    date: '01 Oct 2025 17:54:49 IST'
  },
  {
    category: 'Trade',
    image: exportsImg,
    title: 'India\'s Wheat Export totals 526 Kilograms till June, 25',
    date: '30 Sep 2025 18:12:23 IST'
  },
  {
    category: 'Trade',
    image: importsImg,
    title: 'India\'s Country-wise Wheat Imports in H1 FY\'26',
    date: '29 Sep 2025 18:00:31 IST'
  }
];

const Infographics = () => {
  return (
    <section className="infographics-section">
      <div className="infographics-container">
        <div className="section-header">
          <h2>Explore infographics</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          Global commodity stories clearly visualized, instantly understood.
        </p>

        <div className="infographics-grid">
          {infographicsData.map((item, index) => (
            <div key={index} className="infographic-card">
              <div className="infographic-image">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="infographic-content">
                <span className="infographic-category">{item.category}</span>
                <h4>{item.title}</h4>
                <div className="infographic-footer">
                  <span className="infographic-date">{item.date}</span>
                  <button className="bookmark-btn"><FaBookmark /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Infographics;